import React, { useEffect } from 'react';
import { Grid, Card, IconButton, List, ListItem as ListItemBase, ListItemText, Toolbar } from "@mui/material";
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ArrowBack } from "@mui/icons-material";
import { RootGrid, HeaderTypography } from '../catalogmanager/containers/settings/containers/taxonomy';
import { pocPrimary, pageContentGap } from '../../theme';
import supplierOnly from '../../components/supplier_retailer_only';

// ListItem's legacy `button` prop isn't part of the typed API in this MUI
// version; cast to any at the import boundary (same pattern used elsewhere
// in this migration, e.g. search.tsx/settings/v2/scheduled_tasks.tsx).
const ListItem: any = ListItemBase;

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

type DocumentSettingsProps = {
    setTitle?: (title: string) => void;
    location: { key?: string };
    history: { push: (path: string) => void; goBack: () => void };
};

const DocumentSettings = (props: DocumentSettingsProps) => {
    const { setTitle, location, history } = props;

    useEffect(() => {
        if (setTitle) {
            setTitle('Doc. Settings');
        }
    }, [setTitle]);

    return (
            <RootGrid container
                style={{padding: "24px 14px 24px 14px", position: "relative"}}>
                <Grid container justifyContent={"space-between"} direction={"row"} style={{marginBottom: "24px"}}>
                    {/* `item` is a legacy Grid v1 prop with no effect on this MUI version's
                        Grid v2 (every non-container Grid is implicitly an item); preserved
                        as a harmless pass-through via an any-cast rather than dropped, to
                        keep this a type-only change (mirrors gotcha #4's spread convention). */}
                    <Grid {...({item: true} as any)} container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                        <IconButton
                            sx={iconButtonSx}
                            style={{height: "36px", width: "36px"}}
                            onClick={(e) => {
                                e.preventDefault();
                                if (location.key === undefined)
                                    history.push("/settings");
                                else
                                    history.goBack();
                            }}
                            size="large">
                            <ArrowBack style={{height: "18px", width: "18px"}}/>
                        </IconButton>
                        <HeaderTypography>
                            Settings
                        </HeaderTypography>
                    </Grid>
                </Grid>
                <Grid {...({item: true} as any)} size={12}>
                    <Card>
                        <Toolbar className='lbtoolbar'
                                 style={{background: pocPrimary}}
                        >
                            Document Settings
                        </Toolbar>
                        <List style={{padding: 0}}>
                            <ListItem button component={Link} to='/settings/default-payment-terms'>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Payment terms" secondary='Default payment terms for invoices.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-remit-to-addresses'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Remittance addresses" secondary='Default remittance addresses for invoices.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-ship-from-addresses'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Ship from addresses" secondary='Default ship from addresses for shipments.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-return-addresses'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Return addresses" secondary='Default return addresses for orders.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-ack-properties'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Acknowledgement settings" secondary='Default cancellations reasons and estimated ship dates for acknowledgements.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-return-properties'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Return reasons" secondary='Default return reasons for returns.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                            <ListItem button component={Link} to={'/settings/default-shipment-properties'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Shipment settings" secondary='UCC 128 (GS1) company identifier and other shipment settings.' />
                                <ArrowForwardIosIcon color="action"/>
                            </ListItem>
                        </List>
                    </Card>
                </Grid>
            </RootGrid>
        );
};

export default supplierOnly(DocumentSettings);
